import React from 'react';
import { Helmet } from "react-helmet";
import AnimatedVid from './animatedVid/AnimatedVid';
import Article from './article/Article';
import HomeNews from './news/HomeNews';
import Section from './section/Section';

function Home() {
    return (
        <>
            <Helmet>
                <title>Hayq Games</title>
                <meta name="description" content="Hayq Games is a leading mobile game platform technology company and development team." />
                <link rel="canonical" href="http://hayqgames.com/" />
            </Helmet>
            <AnimatedVid />
            <Article />
            <HomeNews />
            <Section />
        </>
    )
}

export default Home
